import { useEffect } from 'react'

import { useProject } from '@/modules/projects'
import { useOpenProjectStore } from '../openProjectStore'

export function TourProjectReporter() {
  const project = useProject()
  const setProject = useOpenProjectStore((state) => state.setProject)

  useEffect(() => {
    setProject(project)
    return () => setProject(null)
  }, [project, setProject])

  return null
}
